@if (asString; as string) {
	{{ string }}
} @else if (asTemplate) {
	<ng-template [ngTemplateOutlet]="asTemplate"></ng-template>
}
